import type {
  Collection,
  GroupResponsibleStore,
  GroupResponsibleTabName,
} from '../domain/types'
import { useGroupResponsibleDependencies } from '@/scopes/account/group-responsible/pages/dependencies'
import { useCommonDependency } from '@/scopes/common/infrastructure/dependencies/common'
import { useSearchParams } from 'next/navigation'
import { identity } from 'ramda'
import * as React from 'react'
import { useStore } from 'zustand'

export function useSetActiveTab() {
  const searchParams = useCommonDependency('queryStringClient')
  const { groupResponsibleStore } = useGroupResponsibleDependencies()
  const store = useStore(groupResponsibleStore, identity<GroupResponsibleStore>)

  const getActiveTab = React.useCallback((): GroupResponsibleTabName => {
    const tab = searchParams.getValue('activeTab')
    const validTabs: GroupResponsibleTabName[] = ['booking', 'participants', 'rooms', 'bus']
    return validTabs.includes(tab as GroupResponsibleTabName) ? (tab as GroupResponsibleTabName) : 'participants'
  }, [searchParams])

  React.useEffect(() => {
    store.changeTab(getActiveTab())
  }, [getActiveTab])
}

export function useCollection(): Collection | null {
  const searchParams = useSearchParams()
  return React.useMemo(() => {
    const collection = searchParams.get('collection')?.trim().toLowerCase()
    if (collection === 'totally_snow' || collection === 'primavera') {
      return collection
    }
    return null
  }, [searchParams])
}
